<template>
  <div class="footer-table">
    <v-layout
      v-if="$vuetify.breakpoint.xsOnly"
      class="white"
    >
      <v-flex
        xs1
        mt-2
        pt-1
        @click="prevPage"
      >
        <v-icon
          medium
          color="sz_grafit"
        >
          navigate_before
        </v-icon>
      </v-flex>
      <v-spacer />
      <v-flex
        xs2
        mt-3
        class="text-xs-center"
      >
        <p class="pagination-text">
          <span class="fw-600">{{ pagination.page }}</span> / {{ lastPage }}
        </p>
      </v-flex>
      <v-spacer />
      <v-flex
        xs1
        mt-2
        pt-1
        @click="nextPage"
      >
        <v-icon
          medium
          color="sz_violet"
        >
          navigate_next
        </v-icon>
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      align-content-center
      px-3
      align-center
      justify-space-between
      row
      fill-height
      class="white"
    >
      <v-flex>
        <p class="mb-0">
          <span class="">{{ $t('list.items_per_page') }} </span>
          <a
            v-for="(item, index) in perPage"
            :key="index"
            :disabled="disablePerPageItem(index) || item.amount === pagination.amount"
            :class="{ 'sz_grafit--text': item.amount === pagination.amount }"
            @click.stop="setItemsPerPage(item.amount)"
          >
            {{ item.amount }}
          </a>
        </p>
      </v-flex>
      <v-flex>
        <p class="text-xs-right mb-0">
          <span v-if="showFirstPage">
            <a
              :class="{ 'sz_grafit--text': pagination.page === 1 }"
              @click.stop="setPage(1)"
            >1</a>
            ...
          </span>
          <a
            v-for="n in getPageList"
            :key="n"
            :disabled="lastPage === 1 || pagination.page === n"
            :class="{ 'sz_grafit--text': n === pagination.page && lastPage !== 1 }"
            @click.stop="setPage(n)"
          >{{ n }}
          </a>
          <span v-if="showLastPage">...
            <a
              :class="{ 'sz_grafit--text': lastPage === pagination.page }"
              @click.stop="setPage(lastPage)"
            >{{ lastPage }}</a>
          </span>
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
    name: 'BasePagination',
    props: {
        amountAll: {
            type: Number,
            default: 0
        },
        pagination: {},
        perPage: {
            type: Array,
            default: () => [{ amount: 20 }, { amount: 50 }, { amount: 100 }]
        }
    },
    computed: {
        lastPage () {
            if (Number.isNaN(this.amountAll) || Number.isNaN(this.pagination.amount)) return 0;
            return Math.ceil(this.amountAll / this.pagination.amount);
        },
        getPageList () {
            const startLimit = this.pagination.page === this.lastPage ? 3 : 2;
            const start = Math.max(0, this.pagination.page - startLimit);
            const end = Math.min(start + 3, this.lastPage);
            const pages = [];
            for (let i = 1; i <= this.lastPage; i++) {
                pages.push(i);
            }
            return pages.slice(start, end);
        },
        showLastPage () {
            return this.lastPage > 3 && this.pagination.page + 1 < this.lastPage;
        },
        showFirstPage () {
            return this.pagination.page > 2;
        }
    },
    methods: {
        setPage (value) {
            this.$emit('page', value);
        },
        setItemsPerPage (value) {
            this.$emit('amount', value);
        },
        nextPage () {
            if (this.pagination.page < this.lastPage) {
                this.setPage(this.pagination.page + 1);
            }
        },
        prevPage () {
            if (this.pagination.page > 1) {
                this.setPage(this.pagination.page - 1);
            }
        },
        disablePerPageItem (index) {
            const prev = this.perPage[index - 1];
            if (prev) {
                return this.amountAll <= prev.amount;
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.footer-table {
  .layout {
    min-height: 50px;
  }
}

a {
  font-size: inherit !important;
}

.pagination-text {
  font-size: 14px;
}
</style>
